
	import { defineComponent, ref, onMounted, reactive } from 'vue'
	import { postWithJson } from 'library/utils/serviceUtil'
	export default defineComponent({
		props: {
			modelValue: String,
			modelModifiers: {
				default: () => ({})
			}
		},
		setup(props, { emit }) {
			let roleId = ref(props.modelValue || '')
			let options: any = ref([])

			function emitValue(id: any) {
				emit('update:modelValue', id.value)
				emit(
					'selected',
					options.value.find((item) => {
						return item.corpId == id.value
					})
				)
			}
			let timeout: null | number = null
			function handleSearch(value: string) {
				fetch(value, (data: Array<any>) => (options.value = data))
			}
			function handleChange(value: string) {
				emitValue(roleId)
				fetch(value, (data: Array<any>) => (options.value = data))
			}
			function fetch(value: string, callback: Function) {
				if (timeout) {
					clearTimeout(timeout)
					timeout = null
				}
				async function fake() {
					const res = await postWithJson('/business/list.np', {
						name: value,
						pageDto: {
							pageNum: 1,
							pageSize: 20
						}
					})
					callback(res.data)
				}
				timeout = setTimeout(fake, 300)
			}
			onMounted(() => {
				handleSearch('')
			})
			return {
				emitValue,
				handleSearch,
				handleChange,
				options,
				roleId
			}
		}
	})
